module.exports = __webpack_public_path__ + "img/9788990878076.3826cb39.jpg";